import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Input, Grid, Button } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Loading from '../../loading';
import Server from '../../../functions/server';

export default class App extends React.Component {

    state = {
        laborList: [], values: {}
    }

    changeStatus() {
        let status = this.state.values.status;
        let name = 'status';
        if (status == 'Active') {
            this.setState({
                values: {
                ...this.state.values,
                [name]: 'Inactive',
                },
            });
        }
        else {
            this.setState({
                values: {
                ...this.state.values,
                [name]: 'Active',
                },
            });
        }
    }

    handleChange = name => event => {
        this.setState({
            values: {
            ...this.state.values,
            [name]: event.target.value,
            },
        });
    };

    submit = () => {
        let context = this;
        context.setState({ load: true, message: 'Add OR Edit Labor Details', });
        let url = Server() + 'AdminControl/Labor/add.php';
        let data = this.state.values;
        if (this.props.item) {
            url = Server() + 'AdminControl/Labor/edit.php';
        }
        $.ajax({
            type: 'POST', url, data,
            success: function (data) {
                if (data == 1) {
                    context.setState({ load: false, values: {}, dialog: false })
                    context.props.refresh();
                }
                else {
                    context.setState({ load: false, values: {}, dialog: false })
                    context.props.refresh();
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    render() {
        let { load, message, dialog, values } = this.state;
        let { item } = this.props;
        return (
            <div>
                <Loading load={load} message={message} />
                { item ?
                    <div style={{cursor: 'pointer'}} 
                        onClick={ () => this.setState({ dialog: true, values: this.props.item }) }>Edit</div>
                    :
                    <Button onClick={ () => this.setState({ dialog: true, values: {} }) }>Add</Button>
                }
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"Labor"} </DialogTitle>
                    <DialogContent>
                        <Grid>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                                <b>Name</b><br/>
                                <Input fluid placeholder='Name' value={values.name} 
                                    onChange={this.handleChange('name')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                                <b>Mobile</b><br/>
                                <Input fluid placeholder='Mobile' value={values.mobile} 
                                    onChange={this.handleChange('mobile')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                                <b>Alt. Mobile</b><br/>
                                <Input fluid placeholder='Alt. Mobile' value={values.altmobile} 
                                    onChange={this.handleChange('altmobile')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                                <b>Email</b><br/>
                                <Input fluid placeholder='Email' value={values.email} 
                                    onChange={this.handleChange('email')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                                <b>Price</b><br/>
                                <Input fluid placeholder='Price' value={values.price} 
                                    onChange={this.handleChange('price')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                                <b>Status</b><br/>
                                <FormControl style={{width: '100%'}}>
                                    <Select  labelId="demo-simple-select-label"
                                        id="demo-simple-select" value={values.status} 
                                        onChange={this.changeStatus.bind(this)}>
                                        <MenuItem value={'Active'}>Active</MenuItem>
                                        <MenuItem value={'Inactive'}>Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid.Column>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                        <Button onClick={this.submit}>Submit</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

}